<template>
	<div class="container pb_0">
		<div class="main type_01">
			<p class="text_t type1">
				{{ $t('rtr_business-operation-global.title1') }}
			</p>
			<p class="text_n">
				{{ $t('rtr_business-operation-global.text1') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.signup') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box mb_16">
					<div class="bg_text_area pt_100">
						<p class="text_t type2 tac">
							{{ $t('rtr_business-operation-global.title2') }}
						</p>
						<p class="text_n tac">
							{{ $t('rtr_business-operation-global.text2') }}
						</p>
					</div>
				</div>
				<div class="bg_box mb_16">
					<div class="bg_text_area center">
						<p class="text_t fc_white tac">
							{{ $t('rtr_business-operation-global.title3') }}<br />
							{{ $t('rtr_business-operation-global.title4') }}
						</p>
					</div>
				</div>

				<div class="bg_box bg_white">
					<div class="bg_text_area left">
						<p class="text_t mb_30">
							{{ $t('rtr_business-operation-global.title5') }}
						</p>
						<p class="text_n">
							{{ $t('rtr_business-operation-global.text3') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Exchange.vue',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
